import { calculateSummary } from './Cell';
import { CellSummaryContext, CellSummaryData, toHoursData } from './common';

export const calculateResourcePlanSummaryData = (startDate: Date, finishDate: Date, context: CellSummaryContext): CellSummaryData => {
    const { resource, calendar, entityType, resourcePlanningLevel, defaultCostRateTableId, entityId } = context;
    const summary = calculateSummary(resource, startDate, finishDate, calendar, entityType, resourcePlanningLevel, defaultCostRateTableId);
    const plan = entityId
        ? (summary.committedByEntity[entityId] ?? 0) + (summary.proposedByEntity[entityId] ?? 0)
        : (summary.committedWork + summary.proposedWork);
    const actual = entityId
        ? (summary.actualByEntity[entityId] ?? 0)
        : summary.actualWork;
    const fullFteCapacityHours = summary.fullFteCapacityHours;

    return {
        hours: toHoursData(plan, actual, 0, summary.capacityHours, summary.availability, fullFteCapacityHours),
        fullFteCapacityHours,
        hasOverage: summary.overage > 0,
        hasLocalOverage: summary.hasLocalOverage,
        hasProposedOverage: entityId
            ? ((summary.proposed_overage_byEntity[entityId] ?? 0) > 0)
            : (summary.proposedWork > summary.availability),
        hasLocalProposedOverage: entityId ? summary.proposed_hasLocalOverage_byEntity[entityId] : false
    };
}
